import { defineStore } from 'pinia'

export const messages = {
  failedToGetAvailableShippingDates: 'Не удалось получить доступные даты для доставки.',
  failedToGetShippingIntervals: 'Не удалось получить интервалы времени для доставки.'
}

type State = {
  shippingDates: []
  shippingIntervals: []
}

const initialState = (): State => ({
  shippingDates: [],
  shippingIntervals: []
})

export const useDalliStore = defineStore('dalli', {
  state: () => initialState(),
  getters: {
    getShippingDates: (state: State) => state.shippingDates,
    getShippingIntervals: (state: State) => state.shippingIntervals
  },
  actions: {
    clearShippingIntervals (): void {
      this.shippingIntervals = []
    },
    clearShippingDates (): void {
      this.shippingDates = []
    },
    dispose (): void {
      this.clearShippingDates()
      this.clearShippingIntervals()
    },
    async fetchAvailableShippingDates (fiasId: string): Promise<void> {
      const { $apiHelper, $toast } = useNuxtApp()

      try {
        const response = await $apiHelper.actions.getAvailableShippingDates(fiasId) as any

        this.shippingDates = response.meta.dates
      } catch (error) {
        console.error(error)

        $toast.error(messages.failedToGetAvailableShippingDates)
      }
    },
    async fetchShippingIntervals (date: string, serviceCode: number, zone: number): Promise<void> {
      const { $apiHelper, $toast } = useNuxtApp()

      try {
        const response = await $apiHelper.actions.getShippingIntervals({ date, serviceCode, zone }) as any

        this.shippingIntervals = response.meta.intervals
      } catch (error) {
        console.error(error)

        $toast.error(messages.failedToGetShippingIntervals)
      }
    }
  }
})
